import i18n from "i18next";
import { initReactI18next } from "react-i18next";


const savedLanguage =
  localStorage.getItem("language") || "en";

i18n
  .use(initReactI18next)
  .init({

    resources: {

      en: {
        translation: {

          adminDashboard:
            "Admin Dashboard",

          parentReportDistribution:
            "Parent Report Distribution",
            installmentManagement:
  "Installment Management",

installmentManagementText:
  "Track registration fees and installment payments.",

registration:
  "Registration",

  printRegisteredStudents:
  "Print Registered Students",

printCompletedFirstInstallment:
  "Print Completed 1st Installment",

printCompletedSecondInstallment:
  "Print Completed 2nd Installment",

printCompletedThirdInstallment:
  "Print Completed 3rd Installment",

registeredStudents:
  "Registered Students",

studentsCompletedFirstInstallment:
  "Students Who Completed 1st Installment",

studentsCompletedSecondInstallment:
  "Students Who Completed 2nd Installment",

studentsCompletedThirdInstallment:
  "Students Who Completed 3rd Installment",

firstInstallment:
  "1st Installment",

secondInstallment:
  "2nd Installment",

  "discount": "Discount",
"amountPayable": "Amount Payable",

thirdInstallment:
  "3rd Installment",

printRegistrationDefaulters:
  "Print Registration Defaulters",

printFirstInstallmentDefaulters:
  "Print 1st Installment Defaulters",

printSecondInstallmentDefaulters:
  "Print 2nd Installment Defaulters",

printThirdInstallmentDefaulters:
  "Print 3rd Installment Defaulters",

searchStudent:
  "Search Student...",

installmentStatus:
  "Installment Status",

registrationDefaulters:
  "Registration Defaulters",

firstInstallmentDefaulters:
  "1st Installment Defaulters",

secondInstallmentDefaulters:
  "2nd Installment Defaulters",

thirdInstallmentDefaulters:
  "3rd Installment Defaulters",

academicYear:
  "Academic Year",

amountOwing:
  "Amount Owing",

totalDefaulters:
  "Total Defaulters",

amountPaid:
  "Amount Paid",

installmentBalance:
  "Installment Balance",

            parentReportDistributionText:
            "Securely send report cards to parents and sponsors via WhatsApp.",

            selectClass:
            "Select Class",

            selectTerm:
            "Select Term",

            studentsFound:
            "Students Found",

            completed:
            "Completed",

            successfullySent:
            "Successfully Sent",

            failed:
            "Failed",

            feeBlocked:
            "Fee Blocked",

            startSendingReports:
            "Start Sending Reports",

            sendingReports:
            "Sending Reports...",

            noStudentsFound:
            "No students found.",

            pleaseSelectClassAndTerm:
            "Please select class and term.",

          schoolManagement:
            "School Management Control Center",

          logout:
            "Logout",


            studentPortal:
            "Student Portal",

            viewResults:
            "View Results",

            viewResultsDesc:
            "Access your academic results and performance",

            viewSubjects:
            "View Subjects",

            viewSubjectsDesc:
            "View subjects assigned to your class and report subject issues",

            uploadFeePayment:
            "Upload Fee Payment",

            uploadFeePaymentDesc:
            "Upload receipt or proof of school fee payment",

            schoolFeesSummary:
            "School Fees Summary",

            selectTerm: "Select Term",

            required:
            "Required",

            paid:
            "Paid",

            balance:
            "Balance",

            paymentHistory:
            "Payment History",

            date:
            "Date",

            method:
            "Method",

            amount:
            "Amount",

          loading:
            "Loading...",

          currentTerm:
            "Current Term",

          resultsReleased:
            "Results Released",

          resultsNotReleased:
            "Results Not Released",

          releaseResults:
            "Release Results",

          lockResults:
            "Lock Results",

          communicationCenter:
            "Parent Communication Center",

          communicationText:
            "Send report cards, reminders, PTA notices, announcements, and important academic updates directly to parents and sponsors.",

          sendReportCards:
            "Send Report Cards",

          sendParentMessages:
            "Send Parent Messages",

          manageInstallments:
  "Manage Installments",

          reportCards:
            "Report Cards",

          reportCardsText:
            "Generate report cards for individual students or classes.",

          openReportGenerator:
            "Open Report Generator",

          feeClearance:
            "Fee Clearance",

          feeClearanceText:
            "Manage school fee clearance and approvals.",

          manageStudentFees:
            "Manage Student Fees",

          promoteStudents:
            "Promote Students",

          promoteStudentsText:
            "Promote qualified students into next classes automatically.",

          selectClass:
            "Select Class",

          promotionAverage:
            "Promotion Average",

            selectAssessments:"Select Assessment",

          promoting:
            "Promoting...",

          documents:
            "Documents",

          documentsText:
            "Generate school ID cards and professional class lists.",

          generateSchoolId:
            "Generate School ID",
            academicReportGenerator:
                "Academic Report Generator",

                academicReportGeneratorText:
                "Instantly generate report cards for individual students or entire classes.",

                class:
                "Class",

                uploadFeePaymentProof: "Upload Fee Payment Proof",

                paymentMethod: "Payment Method",

                teacherDashboard:
  "Teacher Dashboard",

assignedClasses:
  "Assigned Classes",

assignedSubjects:
  "Assigned Subjects",

marksEntered:
  "Marks Entered",

assessments:
  "Assessments",

activeTerm:
  "Active Term",

enterMarks:
  "Enter Marks",

  myAssignments:
  "My Assignments",

  attendanceRegister:
  "Attendance Register",

attendanceDate:
  "Attendance Date",

present:
  "Present",

absent:
  "Absent",

justified:
  "Justified",

progress:
  "Progress",

Welcome:"Welcome",

saveAttendance:
  "Save Attendance",

attendance:
  "Attendance",

backToDashboard:
  "Back to Dashboard",

                selectPaymentMethod:
                "Select payment method",

                nameOfPersonWhoPaid:
                "Name of Person Who Paid",

                amountPaid:
                "Amount Paid",

                dateOfPayment:
                "Date of Payment",

                transactionReference:
                "Transaction Reference (optional)",

                uploadReceipt:
                "Upload Receipt",

                submitPaymentProof:
                "Submit Payment Proof",

                chooseFile:
                "Choose File",

                noFileChosen:
                "No file chosen",

                cash:
                "Cash",

                mobileMoney:
                "Mobile Money",

                bankTransfer:
                "Bank Transfer",

                student:
                "Student",

                term:
                "Term",

                selectStudent:
                "Select Student",

                studentFeeClearance:
                    "Student Fee Clearance",

                    studentFeeClearanceText:
                    "Control which students have cleared school fees.",

                    chooseClass:
                    "Choose Class",

                    feesCleared:
                    "Fees Cleared",

                    feesNotCleared:
                    "Fees Not Cleared",

                    saveChanges:
                    "Save Changes",

                    updating:
                    "Updating...",

                generateStudentReport:
                "Generate Student Report",

                generateEntireClass:
                "Generate Entire Class",

                studentCount:
                "student(s) in this class",

                generating:
                "Generating...",

                processing:
                "Processing...",

            parentCommunicationCenter:
                "Parent Communication Center",

                parentCommunicationText:
                "Send important announcements, PTA reminders, academic notices, and school updates directly to parents and sponsors.",

                message:
                "Message",

                typeMessage:
                "Type message to parents...",

                classAnalyticsDashboard:
                    "Class Analytics Dashboard",

                    back:
                    "Back",

                    selectSequence:
                    "Select Sequence",

                    generateAnalytics:
                    "Generate Analytics",

                    classAverage:
                    "Class Average",

                    mySubjects:
                        "My Subjects",

                        subjectsAssignedToYou:
                        "Subjects Assigned To You",

                        teacherNotAssigned:
                        "Teacher: Not Assigned",

                        subjectComplaint:
                        "Subject Complaint",

                        subjectComplaintDesc:
                        "Report a missing subject or a subject you are not offering.",

                        missingSubject:
                        "Missing Subject",

                        wrongSubject:
                        "Wrong Subject",

                        subjectNotOffered:
                        "Subject Not Offered",

                        explainIssue:
                        "Explain your issue...(required)",

                        submitComplaint:
                        "Submit Complaint",

                        complaintHistory:
                        "Complaint History",

                        status:
                        "Status",

                        complaint:
                        "Complaint",

                        teacher:
                        "Teacher",

                    highestScore:
                    "Highest Score",

                    lowestScore:
                    "Lowest Score",

                    passRate:
                    "Pass Rate",

                    schoolIdCardGenerator:
                        "School ID Card Generator",

                        printIdCard:
                        "Print ID Card",

                        professionalClassListGenerator:
                        "Professional Class List Generator",

                        printPdf:
                        "Print PDF",

                        academicYearStudentRegister:
                        "Academic Year Student Register",

                        total:
                        "Total",

                        boys:
                        "Boys",

                        girls:
                        "Girls",

                        fullName:
                        "Full Name",

                        admissionNo:
                        "Admission No",

                        gender:
                        "Gender",

                        male:
                        "Male",

                        female:
                        "Female",

                    failRate:
                    "Fail Rate",

                    bestStudent:
                    "Best Student",

                    subjectPerformanceAnalysis:
                    "Subject Performance Analysis",

                    studentSequencePerformance:
                    "Student Sequence Performance",

                    subject:
                    "Subject",

                    average:
                    "Average",

                    highest:
                    "Highest",

                    lowest:
                    "Lowest",

                    studentName:
                    "Student Name",

                sent:
                "Sent",

                sendMessageToParents:
                "Send Message to Parents",


                schoolIdCardGenerator:
                    "School ID Card Generator",

                    printIdCard:
                    "Print ID Card",

                    professionalClassListGenerator:
                    "Professional Class List Generator",

                    printPdf:
                    "Print PDF",

                    academicYearStudentRegister:
                    "Academic Year Student Register",

                    total:
                    "Total",

                    boys:
                    "Boys",

                    girls:
                    "Girls",

                    fullName:
                    "Full Name",

                    admissionNo:
                    "Admission No",

                    gender:
                    "Gender",

                    male:
                    "Male",

                    female:
                    "Female",

                sendingMessages:
                "Sending Messages...",

          generateClassList:
            "Generate Class List",

          classAnalytics:
            "Class Analytics",

          promotionResults:
            "Promotion Results",

          totalStudents:
            "Total Students",

          promoted:
            "Promoted",

          repeated:
            "Repeated",
        }
      },

      fr: {
        translation: {

          adminDashboard:
            "Tableau de Bord Administrateur",

          schoolManagement:
            "Centre de Gestion Scolaire",

            parentCommunicationCenter:
                "Centre de Communication des Parents",

                parentCommunicationText:
                "Envoyez directement aux parents et tuteurs les annonces importantes, rappels PTA, avis académiques et informations scolaires.",

                message:
                "Message",

                classAnalyticsDashboard:
                    "Tableau de Bord des Analyses de Classe",

                    back:
                    "Retour",

                    selectSequence:
                    "Sélectionner une Séquence",

                    studentPortal:
                    "Portail Étudiant",

                    viewResults:
                    "Voir les Résultats",

                    viewResultsDesc:
                    "Consulter vos résultats académiques et performances",

                    viewSubjects:
                    "Voir les Matières",

                    mySubjects:
                        "Mes Matières",

                        subjectsAssignedToYou:
                        "Matières Qui Vous Sont Attribuées",

                        teacherNotAssigned:
                        "Enseignant : Non Assigné",

                        subjectComplaint:
                        "Réclamation de Matière",

                        subjectComplaintDesc:
                        "Signalez une matière manquante ou une matière que vous ne suivez pas.",

                        missingSubject:
                        "Matière Manquante",

                        uploadFeePaymentProof:
                        "Télécharger la Preuve de Paiement",

                        paymentMethod:
                        "Mode de Paiement",

                        selectPaymentMethod:
                        "Sélectionnez le mode de paiement",

                        nameOfPersonWhoPaid:
                        "Nom de la Personne Ayant Effectué le Paiement",

                        printRegisteredStudents:
  "Imprimer les Élèves Inscrits",

printCompletedFirstInstallment:
  "Imprimer les Élèves Ayant Terminé le 1er Vers",

printCompletedSecondInstallment:
  "Imprimer les Élèves Ayant Teminé le 2èm Vers",

printCompletedThirdInstallment:
  "Imprimer les Élèves Ayant Teminé le 3èm Vers",

registeredStudents:
  "Élèves Inscrits",

studentsCompletedFirstInstallment:
  "Élèves ayant terminé le 1er vers.",

studentsCompletedSecondInstallment:
  "Élèves Ayant Terminé le 2ème Vers",

studentsCompletedThirdInstallment:
  "Élèves Ayant Terminé le 3ème Vers",

                        amountPaid:
                        "Montant Payé",

                        dateOfPayment:
                        "Date du Paiement",

                        transactionReference:
                        "Référence de Transaction (optionnel)",

                        uploadReceipt:
                        "Télécharger le Reçu",

                        submitPaymentProof:
                        "Soumettre la Preuve de Paiement",

                        chooseFile:
                        "Choisir un Fichier",

                        noFileChosen:
                        "Aucun fichier sélectionné",

                        cash:
                        "Espèces",

                        mobileMoney:
                        "Mobile Money",

                        bankTransfer:
                        "Virement Bancaire",

                        wrongSubject:
                        "Matière Incorrecte",

                        subjectNotOffered:
                        "Matière Non Suivie",

                        explainIssue:
                        "Expliquez votre problème...(requis)",

                        submitComplaint:
                        "Soumettre la Réclamation",

                        complaintHistory:
                        "Historique des Réclamations",

                        status:
                        "Statut",

                        complaint:
                        "Réclamation",

                        teacher:
                        "Enseignant",

                    viewSubjectsDesc:
                    "Consulter les matières de votre classe et signaler des problèmes",

                    uploadFeePayment:
                    "Téléverser un Paiement",

                    uploadFeePaymentDesc:
                    "Téléverser un reçu ou une preuve de paiement des frais scolaires",

                    schoolFeesSummary:
                    "Résumé des Frais Scolaires",

                    required:
                    "Montant Requis",

                    paid:
                    "Montant Payé",

                    Welcome:"Bienvenue",

                    balance:
                    "Solde",

                    paymentHistory:
                    "Historique des Paiements",

                    date:
                    "Date",

                    method:
                    "Méthode",

                    amount:
                    "Montant",

                    generateAnalytics:
                    "Générer les Analyses",

                    classAverage:
                    "Moyenne de Classe",

                    highestScore:
                    "Meilleure Note",

                    lowestScore:
                    "Plus Faible Note",

                    schoolIdCardGenerator:
                        "Générateur de Cartes d'Identité Scolaires",

                        printIdCard:
                        "Imprimer la Carte",

                        professionalClassListGenerator:
                        "Générateur de Liste de Classe Professionnelle",

                        printPdf:
                        "Imprimer le PDF",

                        academicYearStudentRegister:
                        "Registre des Élèves de l'Année Académique",

                        total:
                        "Total",

                        boys:
                        "Garçons",

                        girls:
                        "Filles",

                        fullName:
                        "Nom Complet",

                        admissionNo:
                        "Matricule",

                        gender:
                        "Sexe",

                        male:
                        "Masculin",

                        female:
                        "Féminin",

                    passRate:
                    "Taux de Réussite",

                    failRate:
                    "Taux d'Échec",

                    bestStudent:
                    "Meilleur Élève",

                    subjectPerformanceAnalysis:
                    "Analyse des Performances par Matière",

                    studentSequencePerformance:
                    "Performance des Élèves par Séquence",

                    subject:
                    "Matière",

                    average:
                    "Moyenne",

                    highest:
                    "Maximum",

                    lowest:
                    "Minimum",

                    studentName:
                    "Nom de l'Élève",

                academicReportGenerator:
                    "Générateur de Bulletins Scolaires",

                    academicReportGeneratorText:
                    "Générez instantanément les bulletins pour un élève ou une classe entière.",

                    class:
                    "Classe",

                    student:
                    "Élève",

                    term:
                    "Trimestre",

                    selectStudent:
                    "Sélectionner un Élève",

                    selectAssessments:"Sélectionner l'évaluation",
                    
                    selectTerm:"Sélectionner le trimestre",
                    studentFeeClearance:
                        "Validation des Frais Scolaires",

                        studentFeeClearanceText:
                        "Contrôlez quels élèves ont payé leurs frais scolaires.",

                        chooseClass:
                        "Choisir une Classe",

                        feesCleared:
                        "Frais Payés",

                        feesNotCleared:
                        "Frais Non Payés",

                        saveChanges:
                        "Enregistrer les Modifications",

                        updating:
                        "Mise à Jour...",

                    generateStudentReport:
                    "Générer le Bulletin",

                    generateEntireClass:
                    "Générer Toute la Classe",

                    studentCount:
                    "élève(s) dans cette classe",

                    generating:
                    "Génération...",

                    processing:
                    "Traitement...",

                typeMessage:
                "Saisissez un message destiné aux parents...",

                sent:
                "Envoyés",

                sendMessageToParents:
                "Envoyer un Message aux Parents",

                sendingMessages:
                "Envoi des Messages...",

          parentReportDistribution:
            "Distribution des Bulletins aux Parents",

            parentReportDistributionText:
            "Envoyez en toute sécurité les bulletins scolaires aux parents et tuteurs via WhatsApp.",

            selectClass:
            "Sélectionner une Classe",

            selectTerm:
            "Sélectionner un Trimestre",

            studentsFound:
            "Élèves Trouvés",

            completed:
            "Terminé",

            schoolIdCardGenerator:
                "Générateur de Cartes d'Identité Scolaires",

                printIdCard:
                "Imprimer la Carte",

                professionalClassListGenerator:
                "Générateur de Liste de Classe Professionnelle",

                printPdf:
                "Imprimer le PDF",

                academicYearStudentRegister:
                "Registre des Élèves de l'Année Académique",

                total:
                "Total",

                boys:
                "Garçons",

                girls:
                "Filles",

                fullName:
                "Nom Complet",

                admissionNo:
                "Matricule",

                gender:
                "Sexe",

                male:
                "Masculin",

                female:
                "Féminin",

            successfullySent:
            "Envoyés avec Succès",

            failed:
            "Échec",

            feeBlocked:
            "Bloqués pour Frais Impayés",

            startSendingReports:
            "Commencer l'Envoi des Bulletins",

            sendingReports:
            "Envoi des Bulletins...",

            noStudentsFound:
            "Aucun élève trouvé.",

            pleaseSelectClassAndTerm:
            "Veuillez sélectionner une classe et un trimestre.",

          logout:
            "Déconnexion",

          loading:
            "Chargement...",

          currentTerm:
            "Trimestre Actuel",

          resultsReleased:
            "Résultats Publiés",

          resultsNotReleased:
            "Résultats Non Publiés",

          releaseResults:
            "Publier les Résultats",

            installmentManagement:
  "Gestion des Versements",

installmentManagementText:
  "Suivre les frais d'inscription et les versements scolaires.",

registration:
  "Inscription",

firstInstallment:
  "1er Versement",

secondInstallment:
  "2ème Versement",

thirdInstallment:
  "3ème Versement",

printRegistrationDefaulters:
  "Imprimer les Défaillants d'Inscription",

printFirstInstallmentDefaulters:
  "Imprimer les Défaillants du 1er Versement",

printSecondInstallmentDefaulters:
  "Imprimer les Défaillants du 2ème Versement",

  myAssignments:
  "Mes Attributions",

attendance:
  "Présences",

backToDashboard:
  "Retour au Tableau de Bord",

  attendanceRegister:
  "Registre de Présence",

attendanceDate:
  "Date de Présence",

present:
  "Présent",

absent:
  "Absent",

justified:
  "Absence Justifiée",

progress:
  "Progression",

saveAttendance:
  "Enregistrer la Présence",

printThirdInstallmentDefaulters:
  "Imprimer les Défaillants du 3ème Versement",

searchStudent:
  "Rechercher un Élève...",

installmentStatus:
  "Statut des Versements",

  "discount": "Réduction",
"amountPayable": "Montant à payer",

registrationDefaulters:
  "Défaillants d'Inscription",

firstInstallmentDefaulters:
  "Défaillants du 1er Versement",

secondInstallmentDefaulters:
  "Défaillants du 2ème Versement",

thirdInstallmentDefaulters:
  "Défaillants du 3ème Versement",

academicYear:
  "Année Académique",

  teacherDashboard:
  "Tableau de Bord Enseignant",

assignedClasses:
  "Classes Assignées",

assignedSubjects:
  "Matières Assignées",

marksEntered:
  "Notes Saisies",

assessments:
  "Évaluations",

activeTerm:
  "Trimestre Actif",

enterMarks:
  "Saisir les Notes",

amountOwing:
  "Montant Restant",

totalDefaulters:
  "Nombre Total de Défaillants",

amountPaid:
  "Montant Payé",

installmentBalance:
  "Solde du Versement",
  manageInstallments:
  "Gérer les Versements",

          lockResults:
            "Verrouiller les Résultats",

          communicationCenter:
            "Centre de Communication des Parents",

          communicationText:
            "Envoyer les bulletins, rappels, avis PTA, annonces et informations académiques importantes directement aux parents et tuteurs.",

          sendReportCards:
            "Envoyer les Bulletins",

          sendParentMessages:
            "Envoyer des Messages",

          reportCards:
            "Bulletins",

          reportCardsText:
            "Générer les bulletins pour les élèves ou les classes.",

          openReportGenerator:
            "Ouvrir le Générateur",

          feeClearance:
            "Gestion des Frais",

          feeClearanceText:
            "Gérer les validations et paiements des frais scolaires.",

          manageStudentFees:
            "Gérer les Frais",

          promoteStudents:
            "Promouvoir les Élèves",

          promoteStudentsText:
            "Promouvoir automatiquement les élèves qualifiés.",

          selectClass:
            "Sélectionner une Classe",

          promotionAverage:
            "Moyenne de Promotion",

          promoting:
            "Promotion en cours...",

          documents:
            "Documents",

          documentsText:
            "Générer les cartes scolaires et listes de classe.",

          generateSchoolId:
            "Générer les Cartes Scolaires",

          generateClassList:
            "Générer la Liste de Classe",

          classAnalytics:
            "Analyse de Classe",

          promotionResults:
            "Résultats de Promotion",

          totalStudents:
            "Nombre d'Élèves",

          promoted:
            "Promus",

          repeated:
            "Redoublants",
        }
      }
    },

    lng: savedLanguage,

    fallbackLng: "en",

    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;